import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/returns.scss";

function Returns() {
  return (
    <div className="returns">
      <Header />
      <div className="shopify-policy__container">
        <div className="shopify-policy__title">
          <h1>Refund policy</h1>
        </div>
        <div className="shopify-policy__body">
          <div className="rte prose max-w-none">
            <p>
              <span style={{ textDecoration: "underline" }}>
                <strong>Returns</strong>
              </span>
              <br />
              <br />
              <span style={{ margin: 0, padding: 0 }}>
                If you are not satisfied with your purchase, you can return
                items within 30 days of receiving your order. Returns
                accompanied by the original receipt will be refunded in the same
                form of payment used.
              </span>
              <br />
              &nbsp; <br />
              <span style={{ textDecoration: "underline" }}>
                <strong>Damaged and Defective items</strong>
              </span>
              <br />
              <br />
              If a package arrives damaged from the carrier, refuse it. If you
              sign for or keep the package, note the damage when signing for it
              so that a claim may be filed with the carrier. Damaged or
              defective products are allowed for replacement or credit within 30
              days of the original date of purchase.
            </p>
            <ol />
            <div>
              Defective products can be exchanged or refunded within 30 days
              from the original purchase date or during the warranty
              period.&nbsp;
            </div>
            <p>
              &nbsp; <br />
              <span style={{ textDecoration: "underline" }}>
                <strong>Incorrect item Sent</strong>
              </span>
            </p>
            <ol>
              <li>
                <span style={{ margin: 0, padding: 0 }}>
                  If you receive the wrong item, please reach out to Petoutlet
                  Consumer Services at&nbsp;
                  <a href="mailto:audit@petoutlet.work">
                    audit@petoutlet.work
                  </a>{" "}
                  for more information.
                </span>
              </li>
            </ol>
            <p>
              <span style={{ textDecoration: "underline" }}>
                <strong>Order cancellation</strong>
              </span>
              <br />
            </p>
            <ol />
            <div>
              <span style={{ margin: 0, padding: 0 }}>
                If you wish to cancel your order, you may do so within 4 hours
                of placing it by selecting the Cancel Order button in your order
                confirmation email. Please contact the Petoutlet Consumer
                Services Team at&nbsp;
                <a href="mailto:audit@petoutlet.work">
                  audit@petoutlet.work
                </a>{" "}
                if you need further assistance. Orders cannot be canceled after
                4 hours.
              </span>
            </div>
            <p>
              &nbsp; <br />
              <span style={{ textDecoration: "underline" }}>
                <strong>Credits</strong>
              </span>
              <br />
            </p>
            <div>
              All refunds will be issued back to the original payment method.
              Please note that credit card companies differ in the time it takes
              to post refunds to your account, and we cannot control when you
              will receive your credit.
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Returns;
